module.exports = __webpack_public_path__ + "img/nt52-00a-80-1.asm.815e5e2a.jpg";